import { QueryClientProvider } from '@tanstack/react-query'
import { MsalProvider } from '@azure/msal-react'
import { RouterProvider } from 'react-router-dom'
import { Toaster } from 'sonner'
import { queryClient } from '@/app/query-client'
import { msalInstance } from '@/app/auth/msal-instance'
import { VisionClientProvider } from '@/app/vision-client-provider'
import { ErrorBoundary } from '@/components/error-boundary'
import { IconContext } from '@/components/icons'
import { router } from '@/routes/router'

export function App() {
  return (
    <ErrorBoundary>
      <MsalProvider instance={msalInstance}>
        <QueryClientProvider client={queryClient}>
          <VisionClientProvider>
            {/* Phosphor renders every glyph in the bold weight app-wide. */}
            <IconContext.Provider value={{ weight: 'bold' }}>
              <RouterProvider router={router} />
              <Toaster position="bottom-right" richColors closeButton toastOptions={{ duration: 5000 }} />
            </IconContext.Provider>
          </VisionClientProvider>
        </QueryClientProvider>
      </MsalProvider>
    </ErrorBoundary>
  )
}
